import { Observable, OperatorFunction } from 'rxjs';
import { timeout } from 'rxjs/operators';

export function timeoutWhen<T>(value: number): OperatorFunction<T, T> {
  return function (source: Observable<T>): Observable<T> {
    return source.pipe(timeout(value));
  };
}
